<ng-container [formGroup]="form">
  <app-input name="email" type="email" (keyup.enter)="handleSubmit()" formControlName="email">
    E-mailadres
  </app-input>
  <app-input name="password" type="password" (keyup.enter)="handleSubmit()" formControlName="password">
    Wachtwoord
  </app-input>
</ng-container>

<div id="invalid">
  @if (form.hasError('email')) {
    <div class="text-primary text-center">Ongeldig e-mailadres</div>
  }
  @if (form.hasError('invalid')) {
    <div class="text-primary text-center">Ongeldige inloggegevens</div>
  }
  @if (form.hasError('server_error')) {
    <div class="text-primary text-center">
      Er is momenteel een storing waardoor je niet kunt inloggen. We doen ons best dit zo snel mogelijk op te lossen.
    </div>
  }
  @if (form.hasError('too_many_attempts')) {
    <div class="text-primary text-center">
      Je hebt te veel foutieve inlogpogingen gedaan. Probeer het later opnieuw.
    </div>
  }
  @if (form.hasError('invalid_token')) {
    <div class="text-primary text-center">
      Deze link is niet meer geldig.
    </div>
  }
</div>

<div class="login-box">
  <app-button (click)="handleSubmit()" [block]="true" onkeydown="">Inloggen</app-button>
</div>

<div aria-label="Wachtwoord vergeten?" class="link hoverable text-subtitle text-center link-text-only" routerLink="/login/password-forgotten">
  Wachtwoord vergeten?
</div>
